import ReferralsAPI from 'api/ReferralsAPI'
import PracticeTypeEnum from '@/enums/PracticeTypeEnum'

export default {
    methods: {
        reschedule(referral) {
            let refId = referral.id
            let that = this

            let retVal
            if (referral.status === 'RESCHEDULE_REQUESTED') {
                retVal = this.redirectToUpdateSlot(refId)
            } else {
                retVal = ReferralsAPI.reschedule(referral.id).then(() => {
                    return that.redirectToUpdateSlot(refId)
                })
            }
            return retVal
        },

        redirectToUpdateSlot(refId) {
            return ReferralsAPI.getForReschedule(refId).then((result) => {
                this.$router.push({
                    name: `referrals.received.update-slot`,
                    params: {
                        type: 'received',
                        id: refId,
                        action: 'update-slot',
                    },
                    query: {
                        physicianId: result.referredTo,
                        practiceId: result.practiceId,
                        practiceLocationId: result.practiceLocationId,
                        practiceType: this.$auth.isPracticeAncillary() ? PracticeTypeEnum.ANCILLARY : PracticeTypeEnum.PHYSICIAN,
                    },
                })
            })
        },
    },
}
